import styled from "styled-components";
import { colors, screenSizes, typography } from "@streeteasy/design-system";
import ButtonAction, {
  buttonActionThemes
} from "@streeteasy/design-system/button-action";
import TextAction from "@streeteasy/design-system/text-action";

export const Wrapper = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.GRAY_LIGHT};
  display: flex;
  height: 74px;
  position: relative;
  width: 317px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    height: 89px;
    width: calc(100% - 16px);
  }
`;

export const InfoBox = styled.div``;
export const Actions = styled.div`
  align-items: center;
  display: flex;
  position: absolute;
  right: -3px;
  top: ${props => (props.isUserRegistered ? "15px" : "21px")};

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    right: 0;
    top: 16px;
  }
`;
export const OHTime = styled(typography.Body)``;
export const SubInfo = styled(typography.Caption)`
  color: ${colors.TEXT_SECONDARY};
  padding-top: 3px;
`;

export const SubInfoWrapper = styled.div`
  display: flex;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    width: 198px;
  }
`;

export const SignupButton = styled(ButtonAction).attrs({
  type: "button",
  theme: buttonActionThemes.SECONDARY
})`
  height: 32px;
  min-width: 101px;
  padding: 0 12px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    height: 48px;
    width: 112px;
  }
`;

export const CheckIcon = styled.i.attrs({
  className: "fa fa-check"
})`
  font-size: 14px;
  color: ${colors.SUCCESS};
  margin: 4px 6px 0 0;
`;

export const WarningIcon = styled.i.attrs({
  className: "fa fa-exclamation-circle"
})`
  font-size: 14px;
  color: ${colors.NOTICE};
  margin: 4px 6px 0 0;
`;

export const Link = styled(TextAction)`
  font-size: 12px;
  line-height: 16px;
`;

export const RemoveIcon = styled.i.attrs({
  className: "fa fa-times"
})`
  font-size: 14px;
  color: ${colors.TEXT_SECONDARY};
`;

export const RemoveButton = styled(ButtonAction).attrs({
  elementType: "button",
  theme: buttonActionThemes.SECONDARY
})`
  background: none;
  border: none;
  border-left: 1px solid ${colors.GRAY_LIGHT};
  height: auto;
  margin: 0 0 0 -3px;
  min-width: auto;
  padding: 0 0 0 6px;

  &:focus {
    background: none;
    border: none;
    border-left: 1px solid ${colors.GRAY_LIGHT};
  }

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    border: none;

    &:focus {
      border: none;
    }
  }
`;
